import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/eSLfnu5Ux3emp8BdBTaTH6/PYQi1wy.png',
  title: 'Conexión'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p8fSkG1HXxQ37kKmNWMwSX/beL3It6.png',
  title: 'Aplicación en el panel eléctrico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tsqSHgNzRjAwgY3SouqiAb/P34TN6a.png',
  title: 'Diagrama de circuito de potencia realista'
}];
export function ImageCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const goTo = (index: number) => setCurrent(index);
  const goPrev = () => setCurrent(prev => (prev - 1 + images.length) % images.length);
  const goNext = () => setCurrent(prev => (prev + 1) % images.length);
  return <section className="py-8 md:py-12 bg-white overflow-hidden pt-[0px] pb-[0px]" data-id="element-101">
      <div className="max-w-md mx-auto px-4 relative pt-[10px] pb-[10px]" data-id="element-102">
        {/* Image container */}
        <div className="relative overflow-hidden rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-103">
          <div className="flex transition-transform duration-700 ease-in-out" style={{
          transform: `translateX(-${current * 100}%)`
        }} data-id="element-104">
            {images.map((item, index) => <div key={index} className="flex-shrink-0 w-full" data-id="element-105">
                <img src={item.src} alt={item.title} className="w-full h-auto object-contain rounded-xl" loading="lazy" data-id="element-106" />
              </div>)}
          </div>

          {/* Navigation arrows */}
          <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-1.5 transition-colors" aria-label="Imagen anterior" data-id="element-107">
            <ChevronLeft className="w-5 h-5" data-id="element-108" />
          </button>
          <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-1.5 transition-colors" aria-label="Siguiente imagen" data-id="element-109">
            <ChevronRight className="w-5 h-5" data-id="element-110" />
          </button>
        </div>

        {/* Title */}
        <p className="font-bold text-gray-900 text-sm md:text-base text-center mt-3" data-id="element-111">
          {images[current].title}
        </p>

        {/* Dot indicators */}
        <div className="flex justify-center gap-2 mt-3" data-id="element-112">
          {images.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === current ? 'bg-[#D9A441] scale-125' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-113" />)}
        </div>
      </div>
    </section>;
}